import React from "react";
import useGet from "../hooks/useGet";
import { Apis } from "../util/Apis";
import CustomLoading from "./CustomLoading";
import NoSorteos from "./NoSorteos";
import Text from "../styledComponents/TextStyled";
import { BackgroundListRaffle } from "../pages/SorteoList";
import CardSorteo from "./CardSorteo";
import EmptyState from "./EmptyState";

const SorteoListTab = () => {

  const {
    data: dataSorteos,
    loading: loadingSorteos,
    error: errorSorteos,
  } = useGet({
    url: Apis.SORTEOS + "/sorteos",
    initialValue: [],
  });


  return (
    <>
      {loadingSorteos ? (
        <CustomLoading />
      ) : errorSorteos ? (
        <NoSorteos>
          <Text textStyle="small" color="red">
            {errorSorteos.message || "Ocurrió un error al cargar los sorteos"}
          </Text>
        </NoSorteos>
      ) : dataSorteos?.length > 0 ? (
        <BackgroundListRaffle className="custom-scroll">
          {dataSorteos.map((item) => (
            <CardSorteo key={item.id} item={item} />
          ))}
        </BackgroundListRaffle>
      ) : (
        <EmptyState variant="sorteos" />
      )}
    </>
  );
};

export default SorteoListTab;
